import React from "react";

interface FollowUpQuestionsProps {
  questions: string[];
  onSendFollowup: (question: string) => void;
}

const SparkleIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ flexShrink: 0 }}
  >
    <path d="M7 0L8.2 4.8L13 6L8.2 7.2L7 12L5.8 7.2L1 6L5.8 4.8L7 0Z" fill="#6366F1" />
  </svg>
);

const FollowUpQuestions: React.FC<FollowUpQuestionsProps> = ({ questions, onSendFollowup }) => {
  if (!questions || questions.length === 0) return null;

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <SparkleIcon />
        <span style={styles.headerText}>Go Deeper with Superdoc</span>
      </div>
      <div style={styles.questionsContainer}>
        {questions.map((question, index) => (
          <button
            key={index}
            type="button"
            style={styles.questionCard}
            onClick={() => onSendFollowup(question)}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#F3F4F6";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#FFFFFF";
            }}
          >
            <SparkleIcon />
            <span style={styles.questionText}>{question}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    marginTop: "2px",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  headerText: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#111827",
  },
  questionsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  questionCard: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 12px",
    borderRadius: "10px",
    border: "1px solid #E5E7EB",
    backgroundColor: "#FFFFFF",
    cursor: "pointer",
    textAlign: "left",
    width: "100%",
    transition: "background-color 0.15s",
    fontFamily: "inherit",
  },
  questionText: {
    fontSize: "13px",
    color: "#374151",
    lineHeight: "1.4",
  },
};

export default FollowUpQuestions;
